// eslint-disable-next-line import/prefer-default-export
export const buildSeenReleases = (versionIds, storedSeenReleases) => versionIds.map((version) => {
  const stored = storedSeenReleases.find((release) => release.version === version);
  return { version, seen: stored ? stored.seen : false };
});
